import React, { FunctionComponent, useContext } from "react";
import { ArrowIcon } from "@cmsgov/ds-medicare-gov";
import {
  formatDate,
  getPlanName,
  makePlanDetailsUrl,
  makePlanDisplayId,
  useTranslate,
} from "../../../../helpers";
import BasePlanCard from "./BasePlanCard";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl-phraseapp";
import { CurrentCoverageCardProps } from "./CurrentCoverageCard";
import { ExtendedCoverageInfo } from "../../../../@types";
import { AppContext } from "../../../../app/store";
import { AnalyticsActionType } from "../../../../app/contexts/Analytics/types";

export const futureCoverageCardTestId = "future-coverage-card";

interface FutureCoverageCardProps
  extends Omit<CurrentCoverageCardProps, "plan"> {
  futurePlan: ExtendedCoverageInfo;
}

const FutureCoverageCard: FunctionComponent<FutureCoverageCardProps> = ({
  language,
  futurePlan,
  isOutsideOpenEnrollment,
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  const url = window.location.href.split("/summary?")[0];
  const linkText = t("summary_page.links.get_plan_details");
  const futurePlanDetailsLink = makePlanDetailsUrl({
    plan: futurePlan,
    language,
    yearValue: "coverage_year",
  });

  return (
    <BasePlanCard
      dataTestId={futureCoverageCardTestId}
      header={
        isOutsideOpenEnrollment ? (
          t("summary_page.plan_cards.future_coverage.header.OOE")
        ) : (
          <FormattedMessage
            id="summary_page.plan_cards.future_coverage.header.OE"
            values={{ year: futurePlan.coverage_year }}
          />
        )
      }
      subHeader={
        !isOutsideOpenEnrollment
          ? t("summary_page.plan_cards.future_coverage.subheader")
          : undefined
      }
      planHeader={
        <p className="mct-c-summary-page-plan-card__plan-header">
          {getPlanName(futurePlan, language)}
        </p>
      }
      planId={makePlanDisplayId(futurePlan)}
      extraInfo={
        <p className="mct-c-summary-page-plan-card__extra-info">
          <FormattedMessage
            id="summary_page.plan_cards.future_coverage.extra_info"
            values={{
              date: formatDate(
                futurePlan.enrollment_effective_date,
                "M/d/yyyy"
              ),
            }}
          />
        </p>
      }
      footer={
        <>
          <Link
            className="mct-c-summary-page-plan-card__link"
            to={futurePlanDetailsLink}
            onClick={() =>
              dispatch({
                type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
                settings: {
                  linkText,
                  linkUrl: `${url}${futurePlanDetailsLink}`,
                },
              })
            }
          >
            {linkText}
          </Link>
          <ArrowIcon className="ds-u-margin-left--05" direction="right" />
        </>
      }
    />
  );
};

export default FutureCoverageCard;
